import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { format } from '@shared/utilities/formatEmail';
import { environment } from '@env/environment';
const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class PlaidService {
  constructor(private _http: HttpClient) {}

  checkAccount(username): Observable<any> {
    return this._http.get(
      `${baseUrl}/plaid/${format(username)}/check-account-exist`
    );
  }

  getAccessToken(data, userName): Observable<any> {
    return this._http.post(
      `${baseUrl}/plaid/${format(userName)}/item/public_token/exchange`,
      data
    );
  }

  getAccounts(userName): Observable<any> {
    return this._http.get(`${baseUrl}/plaid/${format(userName)}/accounts/get`);
  }

  createStripeToken(data, userName): Observable<any> {
    return this._http.post(
      `${baseUrl}/plaid/${format(userName)}/stripe-token-create`,
      data
    );
  }

  stripeCharge(data, userName): Observable<any> {
    return this._http.post(
      `${baseUrl}/stripe/${format(userName)}/charge/token/pre-order`,
      data
    );
  }

  stripeChargeForOrder(data, userName): Observable<any> {
    return this._http.post(
      `${baseUrl}/stripe/${format(userName)}/charge/token/order`,
      data
    );
  }
}
